import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, MessageCircleIcon, CalendarIcon } from 'lucide-react';
export function Footer() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-carbon relative pt-16 pb-8 px-5 md:px-8 text-sm" data-id="element-139">
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-140" />

      <div className="max-w-7xl mx-auto" data-id="element-141">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-142">
          {/* Column 1: Brand */}
          <div className="space-y-6" data-id="element-143">
            <img src="https://cdn.magicpatterns.com/uploads/mfEytma2VuVhmeK6WHR1zC/IMG_6635.jpg" alt="Doctor Ecommerce Logo" className="h-10 md:h-12 object-contain" data-id="element-144" />
            <h3 className="text-gold font-bold text-lg uppercase tracking-wide" data-id="element-145">
              La cura para negocios estancados.
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-146">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            <div className="flex gap-4" data-id="element-147">
              <a href="#" className="text-gold/70 hover:text-gold transition-colors" data-id="element-148">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-149">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-150" />
                </svg>
              </a>
              <a href="#" className="text-gold/70 hover:text-gold transition-colors" data-id="element-151">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-152">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-153" />
                </svg>
              </a>
              <a href="#" className="text-gold/70 hover:text-gold transition-colors" data-id="element-154">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-155">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-156" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: Servicios */}
          <div data-id="element-157">
            <h4 className="text-gold font-bold mb-6 tracking-widest uppercase" data-id="element-158">
              SERVICIOS
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-159">
              <li data-id="element-160">Meta Ads • Google Ads • TikTok Ads • YouTube Ads</li>
              <li data-id="element-161">Email • SMS • Retargeting Automatizado</li>
              <li data-id="element-162">Automatización con IA para Ventas 24/7</li>
              <li data-id="element-163">Funnels Quirúrgicos por Industria</li>
              <li data-id="element-164">Blindaje Digital & Anti-Ban</li>
              <li data-id="element-165">PR Digital & Posicionamiento en Medios</li>
              <li data-id="element-166">CRM & Data Tracking Avanzado</li>
              <li data-id="element-167">Video Marketing IA • SEO • Branding</li>
              <li data-id="element-168">Gestión de Reputación • Google Maps</li>
              <li data-id="element-169">Diseño Web • Landing Pages • CRO</li>
            </ul>
          </div>

          {/* Column 3: Recursos */}
          <div data-id="element-170">
            <h4 className="text-gold font-bold mb-6 tracking-widest uppercase" data-id="element-171">
              RECURSOS
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-172">
              <li data-id="element-173">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-174">
                  Blog de Estrategia
                </a>
              </li>
              <li data-id="element-175">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-176">
                  Casos de Éxito
                </a>
              </li>
              <li data-id="element-177">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-178">
                  Política de Privacidad
                </a>
              </li>
              <li data-id="element-179">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-180">
                  Términos y Condiciones
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contacto Directo */}
          <div data-id="element-181">
            <h4 className="text-gold font-bold mb-6 tracking-widest uppercase" data-id="element-182">
              CONTACTO DIRECTO
            </h4>
            <ul className="space-y-5 text-gray-400 mb-8" data-id="element-183">
              <li className="flex items-start gap-3" data-id="element-184">
                <MapPinIcon className="w-5 h-5 text-gold shrink-0" data-id="element-185" />
                <span data-id="element-186">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-187">
                <PhoneIcon className="w-5 h-5 text-gold shrink-0" data-id="element-188" />
                <span data-id="element-189">402-872-0639</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-190">
                <MailIcon className="w-5 h-5 text-gold shrink-0" data-id="element-191" />
                <span data-id="element-192">doctor.ecommerceus@gmail.com</span>
              </li>
            </ul>

            <div className="space-y-3" data-id="element-193">
              <a href="https://wa.me/14028720639" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-emerald text-white font-bold py-3 px-4 rounded hover:bg-emerald/90 transition-colors uppercase tracking-wide text-xs md:text-sm" data-id="element-194">
                <MessageCircleIcon className="w-5 h-5" data-id="element-195" />
                Habla con un Especialista
              </a>
              <button onClick={scrollToContact} className="flex items-center justify-center gap-2 w-full bg-gold text-carbon font-bold py-3 px-4 rounded hover:bg-gold/90 transition-colors uppercase tracking-wide text-xs md:text-sm" data-id="element-196">
                <CalendarIcon className="w-5 h-5" data-id="element-197" />
                RESERVAR DIAGNÓSTICO
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section: Partners & Mini Form */}
        <div className="border-t border-dark-100 pt-12 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-198">
          <div data-id="element-199">
            <h5 className="text-gray-500 font-bold mb-6 tracking-widest text-xs uppercase" data-id="element-200">
              PARTNERS CERTIFICADOS Y TECNOLOGÍA DE ÉLITE
            </h5>
            <div className="flex flex-wrap gap-4" data-id="element-201">
              <div className="bg-white rounded px-4 py-2 flex items-center justify-center h-12 w-24" data-id="element-202">
                <span className="text-black font-bold text-xs uppercase" data-id="element-203">
                  Meta
                </span>
              </div>
              <div className="bg-white rounded px-4 py-2 flex items-center justify-center h-12 w-24" data-id="element-204">
                <span className="text-black font-bold text-xs uppercase" data-id="element-205">
                  Google
                </span>
              </div>
              <div className="bg-white rounded px-4 py-2 flex items-center justify-center h-12 w-24" data-id="element-206">
                <span className="text-black font-bold text-xs uppercase" data-id="element-207">
                  Shopify
                </span>
              </div>
            </div>
          </div>

          <div data-id="element-208">
            <h5 className="text-gray-500 font-bold mb-6 tracking-widest text-xs uppercase" data-id="element-209">
              ¿QUIERES QUE TE CONTACTEMOS?
            </h5>
            <form className="flex flex-wrap gap-3" data-id="element-210">
              <input type="text" placeholder="Tu Nombre" className="bg-dark-300 border border-dark-100 rounded px-4 py-3 text-white focus:border-gold outline-none flex-1 min-w-[140px] text-sm placeholder-gray-600" data-id="element-211" />
              <input type="email" placeholder="Tu Email" className="bg-dark-300 border border-dark-100 rounded px-4 py-3 text-white focus:border-gold outline-none flex-1 min-w-[140px] text-sm placeholder-gray-600" data-id="element-212" />
              <input type="tel" placeholder="Tu Teléfono" className="bg-dark-300 border border-dark-100 rounded px-4 py-3 text-white focus:border-gold outline-none flex-1 min-w-[140px] text-sm placeholder-gray-600" data-id="element-213" />
              <input type="text" placeholder="Nombre de tu Empresa" className="bg-dark-300 border border-dark-100 rounded px-4 py-3 text-white focus:border-gold outline-none flex-1 min-w-[140px] text-sm placeholder-gray-600" data-id="element-214" />
              <button type="button" className="bg-gold text-carbon font-bold px-8 py-3 rounded hover:bg-gold/90 transition-colors uppercase tracking-widest text-sm" data-id="element-215">
                ENVIAR
              </button>
            </form>
          </div>
        </div>
      </div>
    </footer>;
}